import React from "react";
import ReactApexChart from "react-apexcharts";

const SCORE_MIN = 300;
const SCORE_MAX = 850;

const tierFor = (score) => {
  if (score == null) return { label: "No Score", color: "#94a3b8" };
  if (score < 580) return { label: "Poor", color: "#f46a6a" };
  if (score < 670) return { label: "Fair", color: "#f1b44c" };
  if (score < 740) return { label: "Good", color: "#f6c23e" };
  if (score < 800) return { label: "Very Good", color: "#34c38f" };
  return { label: "Excellent", color: "#0aa88f" };
};

/** Small radial gauge for a FICO-style (300-850) credit score. */
const CreditScoreGauge = ({ score }) => {
  const { label, color } = tierFor(score);
  const pct = score != null
    ? Math.max(2, Math.min(100, Math.round(((score - SCORE_MIN) / (SCORE_MAX - SCORE_MIN)) * 100)))
    : 0;

  const options = {
    chart: { type: "radialBar", sparkline: { enabled: true } },
    plotOptions: {
      radialBar: {
        hollow: { size: "64%" },
        track: { background: "#f1f5f9" },
        dataLabels: {
          name: { show: false },
          value: {
            offsetY: 6,
            fontSize: "1.3rem",
            fontWeight: 700,
            color: "#1e293b",
            formatter: () => (score != null ? score : "—"),
          },
        },
      },
    },
    colors: [color],
    stroke: { lineCap: "round" },
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <div style={{ width: 92, height: 92, flexShrink: 0 }}>
        <ReactApexChart options={options} series={[pct]} type="radialBar" height={92} width={92} />
      </div>
      <div>
        <div className="fw-semibold" style={{ color }}>{label}</div>
        <div className="text-muted" style={{ fontSize: "0.7rem" }}>FICO-style score</div>
      </div>
    </div>
  );
};

export default CreditScoreGauge;
